export const TOGGLE_DEVICE = 'TOGGLE_DEVICE'

export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR'

export const EXPAND_MENU = 'EXPAND_MENU'

export const SWITCH_EFFECT = 'SWITCH_EFFECT'

export const OPEN_NOTIFICATION = 'OPEN_NOTIFICATION'

export const CLEAR_NOTE_QUEUE = 'CLEAR_NOTE_QUEUE'

export const SET_AUTH = 'auth/login'

export const UPDATE_ENDPOINT = 'UPDATE_ENDPOINT'

export const REGISTER_DATA_REFRESH = 'REGISTER_DATA_REFRESH'
export const DEREGISTER_DATA_REFRESH = 'DEREGISTER_DATA_REFRESH'
export const DATA_REFRESH = 'DATA_REFRESH'



// WEBPACK FOOTER //
// ./client/store/mutation-types.js